import React from 'react';
import CircularProgress from '@mui/material/CircularProgress';
import Box from "@mui/material/Box";

export const LoadingButton = ({
  disabled,
  style,
  isLoading = false,
  children,
  ...rest
}) => {
  return (
    <button
      disabled={disabled || isLoading}
      {...rest}
      style={{...style, position: 'relative'}}
    >
      {isLoading &&
        <Box sx={{
          transform: 'translate(-50%, -50%)',
          top: '50%',
          left: '50%',
          position: 'absolute',
          display: 'flex',
          alignItems: 'center',
        }}>
          <CircularProgress
            size={20}
            thickness={5}
            sx={{
              color: `var(--evoblue)`,
            }}
          />
        </Box>
      }
      {children}
    </button>
  );
}